import { RootState } from "../../store";
import { ConnectionStatus } from "../../types/Connection";

export default function isConnectionError(state: RootState): boolean {
  return state.connection.connectionState === ConnectionStatus.ERROR;
}
